import { useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";

export const Seo = ({ title, description }) => {
  const { lang } = useLanguage();
  useEffect(() => {
    if (title) document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    document.documentElement.lang = lang;
  }, [title, description, lang]);
  return null;
};
